import { MPCDeviceDetectionHelper } from "../../helpers/deviceDetectionHelper";

export module MPCPriceValuesRowModule {
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;

    export class PriceValuesRow {
        public htmlElementOrNull: HTMLElement;
        private deviceDetectionHelper: DeviceDetectionHelper;
        private grid: HTMLElement;

        public constructor() {
            const scope: HTMLElement = document.querySelector('.mpc-scope');
            this.grid = scope.querySelector('.grid');
            if (!scope && !this.grid){
                return;
            }

            this.init();
        }

        private init(): void {
            this.deviceDetectionHelper = DeviceDetectionHelper.instance;
            this.htmlElementOrNull = this.grid.querySelector('.prices');

            if (this.deviceDetectionHelper.isMobileShop() || !this.htmlElementOrNull)
                return;

            if (window.shell) {
                window.shell.subscribeTo('ESPP1.ManualProductComparison.PriceModeClassAdded', this.measureValuesRowHeight.bind(this), undefined);
            }
        }

        private measureValuesRowHeight(): void {
            const rowHeight: number = this.htmlElementOrNull.clientHeight;
            this.htmlElementOrNull.style.height = rowHeight + "px";
        }
    }
}